import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/css/tailwind.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import './assets/styles/form-components.css'
import './assets/styles/form-utilities.css'
import './assets/styles/table-styles.css'
import './assets/styles/business-theme.css'
import axios from 'axios'
import { createI18n } from 'vue-i18n'

// Polyfills
import { Buffer } from 'buffer'
window.Buffer = Buffer

// 处理ResizeObserver错误 - 更完善的解决方案
const originalConsoleError = window.console.error;
window.console.error = function (message) {
  if (
    typeof message === 'string' &&
    (message.includes('ResizeObserver') ||
      message.includes('ResizeObserver loop limit exceeded') ||
      message.includes('loop completed with undelivered notifications') ||
      message.includes('ResizeObserver loop completed with undelivered notifications'))
  ) {
    // 完全忽略ResizeObserver循环警告，这是浏览器的已知问题
    return;
  }
  originalConsoleError.apply(this, arguments);
};

// 全局ResizeObserver错误处理
let resizeObserverErrorCount = 0;
const maxResizeObserverErrors = 50; // 增加容错次数

// 处理window error事件中的ResizeObserver错误
window.addEventListener('error', (event) => {
  if (event.message &&
    (event.message.includes('ResizeObserver') ||
      event.message.includes('loop completed with undelivered notifications'))) {
    resizeObserverErrorCount++;
    if (resizeObserverErrorCount > maxResizeObserverErrors) {
      console.warn('ResizeObserver错误过多，已停止处理');
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    return false;
  }
}, true);

// 处理unhandledrejection中的ResizeObserver错误
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason &&
    typeof event.reason === 'string' &&
    (event.reason.includes('ResizeObserver') ||
      event.reason.includes('loop completed with undelivered notifications'))) {
    event.preventDefault();
    return false;
  }
});

// 重写ResizeObserver以防止循环错误
if (window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      const wrappedCallback = (entries, observer) => {
        try {
          // 使用requestAnimationFrame来避免循环
          requestAnimationFrame(() => {
            callback(entries, observer);
          });
        } catch (error) {
          // 忽略ResizeObserver相关错误
          if (!error.message || !error.message.includes('ResizeObserver')) {
            throw error;
          }
        }
      };
      super(wrappedCallback);
    }
  };
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: 'zh', // 设置默认语言
  fallbackLocale: 'en', // 设置备用语言
  messages: {
    zh: {
      common: {
        cancel: '取消',
        confirm: '确认'
      },
    },
    en: {
      common: {
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
    }
  }
})

const app = createApp(App)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})
app.use(i18n)

// 配置 axios 为全局属性
app.config.globalProperties.$axios = axios

// 全局错误处理 - 移除自定义Error构造函数，避免与第三方库冲突
// 只保留console.error的过滤

// 监听全局错误
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver')) {
    event.stopPropagation();
    event.preventDefault();
  }
  // 忽略路由重定向错误
  if (event.message && event.message.includes('Redirected from') && event.message.includes('via a navigation guard')) {
    event.stopPropagation();
    event.preventDefault();
  }
}, true);

app.mount('#app')
